import { EboEmployeeEvent } from '../base-classes/ebo-employee-event';
import { Ask } from '../digital-logs/asks/ask';
import { Settlement } from '../digital-logs/settlements/settlement';
import { PayType } from '../payroll/shared/pay-type.enum';
import { Route } from '../route/route';
import { DigitalLogType } from '../shared/digital-log-type.enum';
import { DisputeReconcile } from './disputes/dispute-reconcile';
import { ReconcileType, ReconcileTypeMapping } from './reconcile-type.enum';

export class Reconcile extends EboEmployeeEvent {
  logType: DigitalLogType;
  type: ReconcileType;
  routeID: string;
  route: Route;
  truckAliasID: string;
  origNum: number;
  destNum: number;
  payTypeID: PayType;
  milesCalc: number;
  milesPaid: number;
  comment: string;
  asks: Ask[];
  settlements: Settlement[];
  disputeReconciles: DisputeReconcile[];

  constructor(jsonData?: Partial<Reconcile>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.route) {
        this.route = new Route(jsonData.route);
      }
      // Initialize collections to empty arrays if not provided
      this.asks = jsonData.asks ? jsonData.asks.map((ask) => new Ask(ask)) : [];
      this.settlements = jsonData.settlements
        ? jsonData.settlements.map((settlement) => new Settlement(settlement))
        : [];
      this.disputeReconciles = jsonData.disputeReconciles
        ? jsonData.disputeReconciles.map((dr) => new DisputeReconcile(dr))
        : [];
    }
  }

  toShortString(): string {
    const response = `${ReconcileTypeMapping[this.type]}`;
    return response;
  }
}
